
// SVG Icon: recapture
export default { id: "terriajs-recapture" };
export const id = "terriajs-recapture";
export const name = "recapture";
